import { Authority } from '@/shared/security/authority';

const BpaUserManagementComponent = () => import('@/admin/user-management/user-management.vue');
const BpaUserManagementViewComponent = () => import('@/admin/user-management/user-management-view.vue');
const BpaUserManagementEditComponent = () => import('@/admin/user-management/user-management-edit.vue');
const BpaDocsComponent = () => import('@/admin/docs/docs.vue');
const BpaConfigurationComponent = () => import('@/admin/configuration/configuration.vue');
const BpaHealthComponent = () => import('@/admin/health/health.vue');
const BpaLogsComponent = () => import('@/admin/logs/logs.vue');
const BpaMetricsComponent = () => import('@/admin/metrics/metrics.vue');

export default [
  {
    path: '/admin/user-management',
    name: 'BpaUser',
    component: BpaUserManagementComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/new',
    name: 'BpaUserCreate',
    component: BpaUserManagementEditComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/:userId/edit',
    name: 'BpaUserEdit',
    component: BpaUserManagementEditComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/:userId/view',
    name: 'BpaUserView',
    component: BpaUserManagementViewComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/docs',
    name: 'BpaDocsComponent',
    component: BpaDocsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/health',
    name: 'BpaHealthComponent',
    component: BpaHealthComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/logs',
    name: 'BpaLogsComponent',
    component: BpaLogsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/metrics',
    name: 'BpaMetricsComponent',
    component: BpaMetricsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/configuration',
    name: 'BpaConfigurationComponent',
    component: BpaConfigurationComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
];
